import State from '@wfp-root-app/store/state';

import { ActionCreators } from '../../login/auth';
import { checkTokenExpiration } from './checkTokenExpiration';

let managerScheduledTiemout;
const ExpirationCheckTimeInterval = 60 * 1000;

function getTokenFromState(state: State) {
    return state.auth.apiToken;
}

function onTokenExpiration(dispatch) {
    dispatch(ActionCreators.refreshToken());
}

function autoRefreshToken() {
    return ActionCreators.refreshToken();
}

function scheduleManagerTokenExpirationChecks() {
    return (dispatch) => {
        if (managerScheduledTiemout) {
            clearInterval(managerScheduledTiemout);
        }

        dispatch(checkTokenExpiration(getTokenFromState, onTokenExpiration, autoRefreshToken));

        managerScheduledTiemout = setInterval(() => {
            dispatch(checkTokenExpiration(getTokenFromState, onTokenExpiration, autoRefreshToken));
        }, ExpirationCheckTimeInterval);
    };
}

export function stopManagerTokenExpirationChecks() {
    if (managerScheduledTiemout) {
        clearInterval(managerScheduledTiemout);
        managerScheduledTiemout = undefined;
    }
}

export default scheduleManagerTokenExpirationChecks;
